import DigilockerCallback from "../../../app/digilockercallback/digilockercallback";

const DigilockerCallbackWrapper = function (props) {
  return <DigilockerCallback />;
};

export default constore(DigilockerCallbackWrapper);
